/* global gon */
import { post, get } from './service'

class PendingAssetsService {
  bulkUpdateStatusUrl = (batchID) => `${gon.turbosquid_product_batches_path}/${batchID}`

  getBulkUpdateStatus = (batchID) => {
    const url = this.bulkUpdateStatusUrl(batchID)
    return get(url)
  }

  saveAssetChanges = (url, data) => post(url, data)
}

export default new PendingAssetsService()
